import StepperProvider from './StepperContext'
import Step from './Step'
import stepFilters from './StepFilters/index'
import { useUserContext } from 'src/components/index'
import { getStepRoutes } from '../../utils'
import { useParams } from 'react-router-dom'
import { StepName } from './types'
import { User } from 'src/types/user'

import styles from './stepper.module.scss'

export interface StepperProps {
    submissionId: string
    collectionId: string
    steps: StepName[]
    ovt?: boolean
    submissionData: any // TODO: proper type
    children: React.ReactNode
}
const Stepper = (props: StepperProps) => {
    const { submissionId, collectionId, steps, ovt = false, children } = props
    const { roles, isStatutoryCustomer, isHesa }: User = useUserContext() as any // TODO: remove the `as any` once useUser is typescripted https://jiscdev.atlassian.net/browse/HDP-3566
    const isAdmin = roles.includes('admin')
    const isAnalyst = isStatutoryCustomer && roles.includes('analyst')

    const params = useParams()

    const getStepPaths = () => {
        const routes = getStepRoutes(ovt, {
            submissionId,
            collectionId,
            ...params,
        })

        Object.entries(routes).forEach(([step, route]) =>
            isAdmin || isAnalyst || isHesa
                ? // @ts-expect-error TODO: fixme once getStepRoutes is typescripted https://jiscdev.atlassian.net/browse/HDP-3566
                  (routes[step] = route.adminPath)
                : // @ts-expect-error TODO: fixme once getStepRoutes is typescripted https://jiscdev.atlassian.net/browse/HDP-3566
                  (routes[step] = route.path),
        )
        return routes
    }

    const stepPaths = getStepPaths()

    return (
        <StepperProvider
            {...props}
            isStatutoryCustomer={isStatutoryCustomer}
            ovt={ovt}
            paths={stepPaths}
            key={`stepper-ctx-${submissionId}`}
        >
            <nav data-test-id="stepper" className={styles.stepper}>
                <ol className={styles.list}>
                    {steps.map(stepName => (
                        <Step
                            key={`step-${stepName}-${submissionId}`}
                            label={stepName}
                            stepFilters={stepFilters[stepName]}
                        />
                    ))}
                </ol>
            </nav>
            {children}
        </StepperProvider>
    )
}

Stepper.displayName = 'Stepper'

export default Stepper
